import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityApplicationOverview } from '@api/data-security';

export const getCoreDataSecurityApplicationOverviewSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityApplicationOverview',
	receive: true,
	request: false,
	requestHandler: getDataSecurityApplicationOverview,
	retainDataOnRequest: true
});
